import { GppModel, TcfEuV2Field } from '@iabgpp/cmpapi';

/**
 * Encodes an IAB TCF v2.2 string via the GPP TCF-EU section (id 2).
 * @iabtcf/core refuses to encode without a fetched Global Vendor List; @iabgpp/cmpapi
 * emits a real TCF v2.2 core string the exchange can decode with go-gdpr.
 * Vendor consent bits are left unset (fail closed). Legitimate interest is never set.
 * cmpId must be an integer greater than 1; 2 is a placeholder until a registered CMP id is assigned.
 */
const CMP_ID = 2;
const CMP_VERSION = 1;
const TCF_POLICY_VERSION = 4;
const PURPOSE_BIT_COUNT = 24;

export interface EncodedConsent {
  tcString: string;
  gppString: string;
}

export function encodeEuConsent(purposeIds: number[], countryCode: string): EncodedConsent {
  const gpp = new GppModel();
  const purposes = bitfield(purposeIds);
  const country = (countryCode || 'DE').slice(0, 2).toUpperCase();

  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.CMP_ID, CMP_ID);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.CMP_VERSION, CMP_VERSION);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.CONSENT_SCREEN, 1);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.CONSENT_LANGUAGE, 'EN');
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.VENDOR_LIST_VERSION, 1);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.POLICY_VERSION, TCF_POLICY_VERSION);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.IS_SERVICE_SPECIFIC, true);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.USE_NON_STANDARD_STACKS, false);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.PURPOSE_ONE_TREATMENT, false);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.PUBLISHER_COUNTRY_CODE, country);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.PURPOSE_CONSENTS, purposes);
  gpp.setFieldValue('tcfeuv2', TcfEuV2Field.PURPOSE_LEGITIMATE_INTERESTS, bitfield([]));

  const tcString = gpp.encodeSection('tcfeuv2');
  const gppString = gpp.encode();
  if (!tcString || !gppString || !gpp.getSectionIds().includes(2)) {
    throw new Error('Unable to encode IAB consent string');
  }
  return { tcString, gppString };
}

function bitfield(purposeIds: number[]): boolean[] {
  return Array.from({ length: PURPOSE_BIT_COUNT }, (_, index) => purposeIds.includes(index + 1));
}
